<div class=" login-bg">
    <div class="login-sb">
        <img [src]="env.login_dedalus_logo" width="50%">
    </div>
    <div class="login">
        <!--div class="logo-flot">
            <img  [src]="env.login_labo_logo">
            <h2>{{env.login_labo_title}}</h2>
        </div-->
    

        <div class="row m-0 h-100 justify-content-center align-items-center">
            <div class="col-md-6 text-center">
                <div class="logo-hosp">
                    <img  [src]="env.login_labo_logo">
                    <h2>{{env.login_labo_title}}</h2>
                </div>
                    <form [formGroup]="form" (ngSubmit)="login()">
                        <div class="row">
                            <mat-form-field class="col-sm-12">
                                <mat-label>Usuario</mat-label>
                                <input matInput type="text"
                                  id="username" autofocus
                                  formControlName="username">
                            </mat-form-field>
                            <mat-form-field class="col-sm-12">
                                <mat-label>Contraseña</mat-label>
                                <input matInput
                                  id="password" autocomplete
                                  formControlName="password"
                                  [type]="hide ? 'password' : 'text'">
                                  <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="row justify-content-center align-items-center">
                            <button mat-raised-button color="primary" type="submit" [disabled]="loading"> Iniciar sesión </button>
                        </div>      
                    </form>
            </div>
        </div>    
    </div>
</div>

<!-- mat-sidenav-container class="example-container">
    <mat-sidenav mode="side" opened style="width: 50%;">Sidenav content</mat-sidenav>
    <mat-sidenav-content style="width: 50%;">
        
        <mat-card class="col-lg-6">
            <mat-card-title>{{titulo}}</mat-card-title>
            <mat-card-content>
                <form [formGroup]="form" (ngSubmit)="login()">
                    <div class="row">
                        <mat-form-field class="col-sm-12">
                            <mat-label>Usuario</mat-label>
                            <input matInput type="text"
                              id="username" autofocus
                              formControlName="username">
                        </mat-form-field>
                        <mat-form-field class="col-sm-12">
                            <mat-label>Contraseña</mat-label>
                            <input matInput type="password"
                              id="password" 
                              formControlName="password">
                        </mat-form-field>
                    </div>
                    <div class="row justify-content-center align-items-center">
                        <button mat-raised-button color="primary" type="submit" [disabled]="loading"> Iniciar sesión </button>
                    </div>      
                </form>
            </mat-card-content>
        </mat-card>

    </mat-sidenav-content>
  </mat-sidenav-container -->
  


